import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserCakeDecoratingGame from 'src/games/CakeDecorating/Main';

interface CakeDecoratingGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class CakeDecoratingGame extends React.Component<CakeDecoratingGameProps> {
    constructor(props: CakeDecoratingGameProps) {
        super(props);
        bindAllOfThis(this, CakeDecoratingGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserCakeDecoratingGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default CakeDecoratingGame;



// WEBPACK FOOTER //
// ./src/pages/game/CakeDecoratingGame.tsx